/**
 *  @class
 *  @function TermsCheckbox
 *
 *  Gate the checkout buttons behind the cart terms checkbox.
 *  Delegated to document level: the cart page and drawer re-render their
 *  markup after load (cart updates, shipping estimates), which detaches any
 *  listener bound to the button node itself.
 */
if (!window.KtechsCartTermsGuard) {
  window.KtechsCartTermsGuard = true;

  // The drawer's checkout button lives in its own nested mini-form, so the
  // container selectors must win over the form fallback.
  const findScope = (node) => node.closest('.cart-drawer-buttons, .thb-cart-form--cart-collaterals') || node.closest('form') || document;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.button.checkout-button');
    if (!button) return;
    const terms = findScope(button).querySelector('terms-checkbox');
    const checkbox = terms ? terms.querySelector('input[type="checkbox"]') : null;
    if (!checkbox || checkbox.checked) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const notice = terms.querySelector('.ktechs_agree-notice');
    if (notice) notice.style.display = 'block';
    terms.classList.remove('ktechs_tacbox--nudge');
    void terms.offsetWidth;
    terms.classList.add('ktechs_tacbox--nudge');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    terms.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' });
    checkbox.focus({ preventScroll: true });
  }, true);

  document.addEventListener('change', (event) => {
    const terms = event.target.closest('terms-checkbox');
    if (!terms || !event.target.matches('input[type="checkbox"]') || !event.target.checked) return;
    const notice = terms.querySelector('.ktechs_agree-notice');
    if (notice) notice.style.display = 'none';
    terms.classList.remove('ktechs_tacbox--nudge');
  });
}

if (!customElements.get('terms-checkbox')) {
  class TermsCheckbox extends HTMLElement {
    constructor() {
      super();
    }
  }
  customElements.define('terms-checkbox', TermsCheckbox);
}
